import { useParams } from 'react-router-dom';
import { FileX2 } from 'lucide-react';

import WaiverPreview from './WaiverPreview';

import PageLoader from '@/components/common/PageLoader';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

import { useCoachActivity } from '@/data/coachActivity';
import { useUserActivityWaiver } from '@/data/userActivityWaiver';

const Waiver = () => {
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);
  const userActivityWaiver = useUserActivityWaiver(
    coachActivity.data.userId,
    coachActivity.data.activityId
  );

  if (userActivityWaiver.isLoading && !userActivityWaiver.data) {
    return <PageLoader />;
  }

  return (
    <>
      <h2 className="text-2xl font-bold">Waiver</h2>
      {!userActivityWaiver.data && (
        <Alert>
          <FileX2 className="h-4 w-4" />
          <AlertTitle>No Waiver Found</AlertTitle>
          <AlertDescription>
            The coach has not signed the waiver yet.
          </AlertDescription>
        </Alert>
      )}
      {userActivityWaiver.data && <WaiverPreview />}
    </>
  );
};

export default Waiver;
